// extracted by mini-css-extract-plugin
module.exports = {"grid":"Columns_grid__rIPb4","column":"Columns_column__SN35M"};